export default __webpack_public_path__ + "static/media/WNo.5-3.ff4e264c.jpg";